
export const eventchangeSearch = "search";
export const eventchangeViewColumns = "viewColumnsChange";
export const eventchangeFilterDialog = "filterChange";
export const eventchangePage = "changePage";
export const eventchangeRowsPerPage = "changeRowsPerPage";